import React, { memo, useEffect } from 'react';
import withQuillLayout from 'src/_common/hoc/QuillLayout';
import { LandingPage } from 'src/researcher/page/LandingPage';
import { PrivateRouteGuard } from 'src/researcher/component/providers/PrivateRouteGuard';
import {
  NotSupportedEnvPage,
  SupportedEnvGuard,
} from 'src/researcher/component/providers/SupportedEnvGuard';
import { ApplicationProvider } from 'src/researcher/context/application';
import { CoWriterLoader } from 'src/researcher/component/common/Loader';
import {
  DialogProvider,
  InitState as InitActiveDialogState,
} from 'src/researcher/context/ui/dialog';
import { ActiveDialogOnPageEnum } from 'src/researcher/context/ui/dialog.types';
import { ActiveDialog } from 'src/researcher/component/common/ActiveDialog';
import { useRouter } from 'next/router';

const InitStore = {
  Dialog: {
    ...InitActiveDialogState,
    dialog: ActiveDialogOnPageEnum.LOADING_DIALOG,
  },
};

const LandingPageStore = (props: React.PropsWithChildren<any>) => (
  <DialogProvider value={InitStore.Dialog}>
    <ApplicationProvider>{props.children}</ApplicationProvider>
  </DialogProvider>
);

function PageComponent() {
  return (
    <SupportedEnvGuard
      renderLoader={CoWriterLoader}
      renderNotSupportedEnvPage={NotSupportedEnvPage}
    >
      <PrivateRouteGuard renderLoader={CoWriterLoader}>
        <ActiveDialog />
        <LandingPage />
      </PrivateRouteGuard>
    </SupportedEnvGuard>
  );
}

const Page = memo(PageComponent);

export default withQuillLayout({
  children: Page,
  Provider: LandingPageStore,
});
